<template>
    <div class="Main">
        <div class="view-wrap">
            <router-view />
        </div>
        <van-tabbar v-model="tabActive" inactive-color="#fff" :active-color="$primary">
            <van-tabbar-item @click="$router.push(item.path)" v-for="(item, index) in tabList" :key="index" :name="index" :icon="item.icon">{{
                item.title
            }}</van-tabbar-item>
        </van-tabbar>
    </div>
</template>
<script>
export default {
    data() {
        return {
            tabList: [
                {
                    icon: "home-o",
                    path: "/home",
                    title: "首页",
                },
                {
                    icon: "contact",
                    path: "/mine",
                    title: "我的",
                },
            ],
            tabActive: 0,
        };
    },
    watch: {
        "$route.path": {
            handler(newV) {
                this.tabList.some((item, index) => {
                    if (item.path == newV) {
                        this.tabActive = index;
                        return true;
                    }
                });
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.Main {
    /deep/.van-tabbar {
        background-color: #2b2b2b;
        .van-tabbar-item--active {
            background-color: #2b2b2b;
        }
    }
    /deep/.van-hairline--top-bottom::after,
    .van-hairline-unset--top-bottom::after {
        border-width: 0;
    }
}
</style>
